import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-star-06',
  standalone: true,
  templateUrl: './rt-icon-star-06.component.html',
  styleUrls: ['./rt-icon-star-06.component.scss']
})
export class RtIconStar06Component {
  @Input() width: number | string = 22;
  @Input() height: number | string = 22;
}
